import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLinuxmintComponent } from './simple-icons-linuxmint.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLinuxmintComponent ],
    exports:      [ SimpleIconsLinuxmintComponent ],
    bootstrap:    []
})
export class SimpleIconsLinuxmintModule {}
